import React from "react";
import "./NavBar.css";
import {NavLink} from "react-router-dom";
import home from "../resources/icons/home.svg";
import user from "../resources/icons/user.svg";
import {FormattedMessage} from "react-intl";

/** A navigation bar to be displayed on the left of all pages */
function NavBar() {
  return (
    <nav className="navBar">
      <NavElement to="/" image={home} labelId="navBar.home" />
      <NavElement to="/groups" image={user} labelId="navBar.groups" />
    </nav>
  );
}

type NavElementProps = {
  to: string;
  image: string;
  /** An id of the message for a FormattedMessage to be displayed */
  labelId: string;
};
/** A navigation element in the navigation bar */
function NavElement({to, image, labelId}: NavElementProps) {
  return (
    <NavLink to={to} className="navBar__link">
      <div className="navBar__imageContainer" aria-hidden="true">
        <img src={image} alt="" />
      </div>
      <FormattedMessage id={labelId} />
    </NavLink>
  );
}

export default NavBar;
